// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 66) return "static/chunks/dc112a36-06db74506b97535a.js";
	if (chunkId === 674) return "static/chunks/674-65d9b98a3eae2cea.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"626":"b234db006474ca04","730":"27538be550903a91","886":"1faf80e49cf218c9"}[chunkId] + ".js";
};